/** @file ENGINE_OPTIONS: the WebGL context options of the pixel-exact engine (readable, straight alpha). */

/** Drawing buffer kept for `readPixels`, no stencil, straight (not premultiplied) alpha, transparent canvas allowed. */
export const ENGINE_OPTIONS = { preserveDrawingBuffer: true, stencil: false, premultipliedAlpha: false, alpha: true } as const;
